var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackgroundColorColor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1tolu0vyza)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.117.933 5.067 0l5.716 5.717c.256.255.384.572.384.95 0 .377-.128.694-.383.95l-3.167 3.166a1.29 1.29 0 0 1-.95.384 1.29 1.29 0 0 1-.95-.384L2.55 7.617a1.29 1.29 0 0 1-.383-.95c0-.378.128-.695.383-.95l3.167-3.184-1.6-1.6zm2.55 2.55L3.484 6.667H9.85L6.667 3.483zm6 7.85c-.367 0-.68-.13-.942-.391a1.284 1.284 0 0 1-.391-.942c0-.233.069-.483.208-.75.139-.267.292-.517.458-.75l.317-.417c.11-.144.228-.283.35-.416.122.133.239.272.35.416l.317.417c.166.233.319.483.458.75S14 9.767 14 10c0 .367-.13.68-.392.942a1.284 1.284 0 0 1-.941.391zM1.333 16v-2.667h13.334V16H1.333z",
    fill: "#500D76"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1tolu0vyza"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundColorColor);
export default __webpack_public_path__ + "static/media/backgroundColorColor.7a3624f6a41f3b5ee0518ec97002d281.svg";
export { ForwardRef as ReactComponent };